import React, { useState, useContext } from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import { Context } from '../../../context/app-context'

import './detailsChallenges.scss'
import Button from '../../atoms/button/button'
import useMediaQuery from '../../../utils/useMediaQuery'
import userSessionStorage from '../../../utils/userSessionStorage'
import useGetWinner from '../../../utils/hooks/useGetWinner'
import { datesFase2 } from '../../../constants/activity-constants'

const DetailsChallenges = ({ banner, infoReto, boxInfoMision, step }) => {
  const { dispatch } = useContext(Context)
  const session = new userSessionStorage()
  const [isWinner] = useGetWinner()

  const isMobile = useMediaQuery()
  const [active, setActive] = useState(false)

  const showChallenge = () => {
    return active ? 'active' : 'noActive'
  }

  const handleOpen = () => {
    setActive(!active)
  }

  return (
    <section
      className={`f-banner-details-challenge-container ${
        !boxInfoMision && 'h-894'
      } ${showChallenge()} ${
        process.env.LOCALE === 'es-PE' && step === 3 && 'h-827'
      }`}
    >
      <div
        className={`f-banner-details-challenge-contentMobile ${showChallenge()}`}
      >
        <GatsbyImage
          objectFit="cover"
          image={withArtDirection(getImage(banner.large), [
            {
              media: '(max-width: 1024px)',
              image: getImage(banner.small),
            },
            {
              media: '(max-width: 1666px)',
              image: getImage(banner.medium),
            },
          ])}
          alt="banner detaller del reto"
          className={`f-banner-details-challenge-container__image ${showChallenge()}`}
        />

        <div
          className={`f-banner-details-challenge-container__information ${showChallenge()}`}
        >
          {infoReto}
          {(!session.getUserInfo() || isWinner) && (
            <Button
              title="INGRESAR TU PUBLICACIÓN"
              color="blue"
              className="large-btn"
              onClick={() =>
                session.getUserInfo()
                  ? dispatch({
                      type: 'set-modal',
                      modalActive: {
                        type: 'modalChallenges',
                        props: {
                          close: () => {
                            dispatch({ type: 'clear-modal' })
                          },
                          onFinish: () => {
                            dispatch({ type: 'clear-modal' })
                          },
                          actualStep: step,
                        },
                        wrapperProps: {
                          className: 'f-modalSendChallenges',
                        },
                      },
                    })
                  : dispatch({
                      type: 'set-modal',
                      modalActive: {
                        type: 'login',
                        props: {
                          close: () => {
                            dispatch({ type: 'clear-modal' })
                          },
                          onFinish: () => {
                            dispatch({ type: 'clear-modal' })
                            window.location.reload()
                          },
                        },
                      },
                    })
              }
            />
          )}
        </div>
        <div
          className={`f-banner-details-challenge-container__boxInfo ${showChallenge()}`}
        >
          {boxInfoMision ? (
            <p>
              Participa <b>CUANTAS VECES QUIERAS</b> hasta el{' '}
              {datesFase2.finishDateFase2}.
              <br /> <br />
              <b>Criterio de selección:</b> creatividad
            </p>
          ) : (
            <p>
              ¡Aquí puedes subir tu reto UNA SOLA VEZ! Revisa súper bien el
              contenido que quieres que quede ingresado.
              <br /> <br />
              <b>Criterio de selección:</b> creatividad <br />
              <b>Fecha Límite:</b> {datesFase2.finishDateFase2}.
            </p>
          )}
        </div>
        {isMobile && (
          <span
            className={`f-frequently-questions__container__question-arrow arrowChallenges ${showChallenge()}`}
            onClick={() => handleOpen()}
          />
        )}
      </div>
    </section>
  )
}

export default DetailsChallenges
